export class CurrencyHelper {
  static currencySymbol(currency) {
    switch (currency) {
      case "eur":
        return "€"
      case "usd":
        return "$"
      case "gbp":
        return "£"
      default:
        console.error("Unknown currency: " + currency)
    }
  }

  // Convert a number to a currency. Supports EUR, USD and GBP.
  static numberToCurrency(amount, symbol) {
    var precision = 2
    var separator = i18n.translations[i18n.locale].js.number.format.separator
    var delimiter = i18n.translations[i18n.locale].js.number.format.delimiter

    var parts = parseFloat(amount).toFixed(precision).split(".")
    var formattedNumber = this.numberWithDelimiter(parts[0], delimiter) + separator + parts[1].toString()

    switch (symbol) {
      case "€":
        return formattedNumber + "€"
      case "$":
        return "$" + formattedNumber + " USD"
      case "£":
        return "£" + formattedNumber
      default:
        console.error("Unknown symbol: " + symbol)
    }
  }

  static numberWithDelimiter(number, delimiter, separator) {
    var delimiter = delimiter || ","
    var separator = separator || "."

    var parts = number.toString().split('.')
    parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + delimiter)
    return parts.join(separator)
  }
}
